import { CSSProperties } from "react";

interface UserPanelItemProps {
  text: string;
  onClick?(): void;
  rightNode: React.ReactNode;
  style?: CSSProperties;
}

export function UserPanelItem(props: UserPanelItemProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid rgba(0,0,0,0.1)",
        alignItems: "center",
        padding: "12px 24px",
        color: "rgba(0,0,0,0.8)",
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <div style={{ fontSize: 14 }}>{props.text}</div>
      <div style={{ fontSize: 24, display: "flex", alignItems: "center" }}>
        {props.rightNode}
      </div>
    </div>
  );
}
